<button 
  class="points__add-new-point-card"
  (click)="handleAddNewPointClick()"
>
  @if (isLoadingResourcesByIdOnEmptySpace()){
    <ci-icon 
      type="svg" 
      name="loader-debounce" 
      scale="3x"
    ></ci-icon>
  } @else {
    <ci-icon 
      type="svg" 
      name="btn-add" 
      scale="3x"
    ></ci-icon>
  }

</button>